import t from "./ghl-ui.es1296.js";
function o(e) {
  return function(r) {
    return t(r, e);
  };
}
export {
  o as default
};
